import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'billingGroups',
  inputShow: gql`
    query billingGroups($input: BillingGroupQueryInput) {
      billingGroups(input: $input) {
        id
        name
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    label: 'Billing Groups',
    group: 'Facilities',
    order: 3,
  },
};
